import './UserPage.css';
import { useContext } from 'react';
import React from 'react';
import LogicContext from '../Context/LogicContext';
import { useNavigate } from 'react-router-dom';
import { settingsService } from '../services/settingsService';
import { SetNotificationList } from '../store/NotificationAtom';

function ModuleListPage() {
  const logicContext = useContext(LogicContext);
  const navigate = useNavigate();
  const setNotifications = SetNotificationList();

  const moduleMenuList = logicContext.getModule();

  const modalSelection = selection => {
    console.log('Module ', selection);
    logicContext.moduleSelect(selection.Module_Id);
    notificationLoader(selection.Module_Id);
    navigate(`/${selection.Module_Id}/${selection.Module_Name.replace(' ', '-')}/dashboard`);
    // navigate(`/${selection.Module_Id}/${selection.Module_Name}/dashboard`);
  };

  const notificationLoader = id => {
    settingsService.getNotificationByModule(id).then(res => {
      if (res?.data?.length) {
        setNotifications(res?.data);
      }
    });
  };

  return (
    <div className="mt-8 max-w-6xl mx-auto grid grid-auto-fit-lg gap-2">
      {Object.keys(moduleMenuList).map((key, i) => {
        return (
          <div
            key={i}
            onClick={() => modalSelection(moduleMenuList[key][0])}
            className="group p-6 bg-moduleColor border border-gray-200 rounded transition duration-500 ease-in-out hover:bg-blue-500 transform hover:-translate-y-1 hover:scale-100 hover:text-white "
          >
            <div className="bg-moduleColor cursor-pointer h-[10vh] w-[10vh] rounded-full md:h-[10vh] group-hover:bg-white">
              {/* <img
                  src={item.photo}
                  className="ml-2 w-55 pt-2 first-line:md:ml-2 pt-2"
                ></img> */}
            </div>
            <p className="mt-2 text-lg font-semibold text-gray-700 group-hover:text-white cursor-pointer xl:text-xl">{key}</p>
            <p className="mt-1 cursor-pointer text-sm text-gray-700 group-hover:text-white">
              {moduleMenuList[key][0]['Module_Description']}
            </p>
          </div>
        );
      })}
    </div>
  );
}

export default ModuleListPage;
